<app-header></app-header>
<div class="wrapper">
  <div class="section_wrapper" style="margin-top: 80px;padding-bottom: 0px;">

    <h6 class="font_40_a32">
      Reset Password
    </h6>

    <form class="example-form input" [formGroup]="form" (ngSubmit)=onSubmit()>
      <div class="form">

        <div class="w-100">
          <mat-form-field class="example-full-width">
            <mat-label>Enter your password</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" name="password" required formControlName="password">
            <button class="show_hide_btn" mat-icon-button matSuffix (click)="hide = !hide"
              [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <span>{{hide ? 'Show' : 'Hide'}}</span>
            </button>
          </mat-form-field>
          <mat-error
            *ngIf="(form.get('password').hasError('required') || form.get('password').hasError('pattern'))&& submitted">
            please enter a password 
            <!-- <div>
              <li>Minimum 8 characters</li>
              <li>Atleast one lowercase letter</li>
              <li>Atleast one uppercase letter</li>
              <li>Atleast one number</li>
              <li>Atleast one special character </li>
            </div> -->

          </mat-error>
        </div>
        <div class="w-100">
          <mat-form-field appeara1nce="fill" class="example-full-width">
            <mat-label>Re-enter your password</mat-label>
            <input matInput [type]="rehide ? 'password' : 'text'" name="repassword" formControlName="repassword">
            <button class="show_hide_btn" mat-icon-button matSuffix (click)="rehide = !rehide"
              [attr.aria-label]="'Hide password'" [attr.aria-pressed]="rehide">
              <span>{{rehide ? 'Show' : 'Hide'}}</span>
            </button>
          </mat-form-field>
          <mat-error class="error-message" *ngIf="form.get('repassword').hasError('required') && submitted">please
            re-enter your password</mat-error>
        </div>
      </div>
      <p *ngIf="isPasswordMismatch" style="color :red">* Both passwords need to be same</p>
      <div class="login">
        <button class="login_btn green_btn" *ngIf="!isLoader">Reset Password
          <img src="../../../assets/icons/arrow_white.svg" alt="">
        </button>
        <app-loader *ngIf="isLoader"></app-loader>
      </div>
    </form>

  </div>


</div>
<app-footer></app-footer>